import React from 'react';
import SEO from '../components/SEO';
import './LegalPage.css';

const TermsPage = () => (
  <div className="legal-page">
    <SEO title="Kullanım Koşulları" path="/kullanim-kosullari" />
    <div className="legal-page__container">
      <h1>Kullanım Koşulları</h1>
      <p className="legal-page__date">Son güncelleme: 26 Temmuz 2026</p>

      <p>isBulsun.com platformunu kullanarak aşağıdaki koşulları kabul etmiş sayılırsınız. Lütfen bu koşulları dikkatlice okuyunuz.</p>

      <h2>1. Hizmet Tanımı</h2>
      <p>isBulsun.com, yapay zeka destekli bir iş arama ve kariyer yönetim platformudur. Platform aşağıdaki hizmetleri sunar:</p>
      <ul>
        <li>CV ve özgeçmiş oluşturma (yapay zeka asistanı ile veya manuel)</li>
        <li>Yapay zeka ile iş ilanı arama ve eşleştirme</li>
        <li>CV analizi ve ATS uyumluluk optimizasyonu</li>
        <li>İş ilanlarına otomatik veya manuel başvuru</li>
        <li>Kariyer raporu ve yetkinlik değerlendirmesi</li>
        <li>Mülakat pratiği</li>
        <li>Yurt dışı (ABD/Kanada) çalışma rehberliği</li>
      </ul>

      <h2>2. Üyelik ve Hesap</h2>
      <ul>
        <li>Platforma Google, Facebook, LinkedIn hesabınız veya e-posta adresiniz ile üye olabilirsiniz.</li>
        <li>Hesap bilgilerinizin güvenliğinden siz sorumlusunuz.</li>
        <li>Bir kişi yalnızca bir hesap oluşturabilir.</li>
        <li>18 yaşından küçükler platforma üye olamaz.</li>
      </ul>

      <h2>3. CV ve Özgeçmiş Verileri</h2>
      <ul>
        <li>Platforma yüklediğiniz veya oluşturduğunuz CV ve özgeçmiş bilgilerinin doğruluğundan siz sorumlusunuz.</li>
        <li>CV'nizi yapay zeka asistanı aracılığıyla veya manuel olarak oluşturabilirsiniz.</li>
        <li>Yüklenen CV dosyaları yapay zeka tarafından analiz edilerek yapılandırılır.</li>
        <li>CV verileriniz, yalnızca sizin onayınızla iş başvurularında kullanılır.</li>
      </ul>

      <h2>4. Yapay Zeka Kullanımı ve Onay</h2>
      <p>Platformumuzu kullanarak aşağıdaki yapay zeka işlemlerine onay vermiş olursunuz:</p>
      <ul>
        <li><strong>CV Analizi:</strong> Yüklediğiniz veya oluşturduğunuz CV'nin yapay zeka tarafından analiz edilmesi, içeriğinin ayrıştırılması ve yapılandırılması</li>
        <li><strong>İş Eşleştirme:</strong> CV'nizdeki bilgilerin iş ilanlarıyla yapay zeka tarafından karşılaştırılması ve uygunluk skoru hesaplanması</li>
        <li><strong>CV Optimizasyonu:</strong> CV'nizin iş ilanı gereksinimlerine göre yapay zeka tarafından iyileştirme önerilerinin oluşturulması</li>
        <li><strong>Otomatik Başvuru:</strong> Onayınız dahilinde yapay zekanın sizin adınıza uygun iş ilanlarına başvuru yapması</li>
        <li><strong>Kariyer Değerlendirmesi:</strong> Yetkinliklerinizin ve kariyer seviyenizin yapay zeka tarafından analiz edilmesi</li>
        <li><strong>Profil Raporu:</strong> Kariyer profili, göç uygunluğu ve yetkinlik raporlarının yapay zeka tarafından oluşturulması</li>
      </ul>
      <p>Yapay zeka tarafından üretilen tüm sonuçlar öneri niteliğindedir. Nihai karar ve sorumluluk kullanıcıya aittir.</p>

      <h2>5. Otomatik Başvuru Onayı</h2>
      <p>Otomatik başvuru özelliğini aktif ettiğinizde:</p>
      <ul>
        <li>Yapay zeka sizin adınıza uygun iş ilanlarına başvuru yapar.</li>
        <li>Başvurularda CV'niz ve profil bilgileriniz işverene iletilir.</li>
        <li>Bu özelliği istediğiniz zaman devre dışı bırakabilirsiniz.</li>
        <li>Yapılan başvuruları "Başvurularım" sayfasından takip edebilirsiniz.</li>
      </ul>

      <h2>6. Kullanıcı Yükümlülükleri</h2>
      <ul>
        <li>Doğru ve güncel bilgi sağlamakla yükümlüsünüz.</li>
        <li>Platformu yasa dışı amaçlarla kullanamazsınız.</li>
        <li>Başkalarının kişisel bilgilerini izinsiz paylaşamazsınız.</li>
        <li>Platformun teknik altyapısına zarar verecek girişimlerde bulunamazsınız.</li>
        <li>Sahte veya yanıltıcı CV bilgileri oluşturamazsınız.</li>
      </ul>

      <h2>7. Fikri Mülkiyet</h2>
      <p>Platformun tasarımı, yazılımı, logosu ve içerikleri isBulsun.com'a aittir. Kullanıcılar tarafından oluşturulan CV ve özgeçmiş içerikleri kullanıcıya aittir.</p>

      <h2>8. Sorumluluk Sınırları</h2>
      <ul>
        <li>isBulsun.com, iş ilanlarının doğruluğunu garanti etmez.</li>
        <li>Yapay zeka önerilerinin kesinliği garanti edilmez.</li>
        <li>İşveren kararları üzerinde isBulsun.com'un bir etkisi yoktur.</li>
        <li>Vize ve göç süreçlerine ilişkin bilgiler genel rehberlik niteliğindedir, hukuki danışmanlık yerine geçmez.</li>
      </ul>

      <h2>9. Hesap Sonlandırma</h2>
      <p>Hesabınızı istediğiniz zaman silebilirsiniz. Hesap silme işlemi ile tüm kişisel verileriniz, CV'leriniz ve başvuru geçmişiniz kalıcı olarak silinir. isBulsun.com, koşulları ihlal eden hesapları önceden bildirim yaparak askıya alabilir veya sonlandırabilir.</p>

      <h2>10. Değişiklikler</h2>
      <p>isBulsun.com bu kullanım koşullarını güncelleme hakkını saklı tutar. Güncellemeler bu sayfada yayınlanır ve platforma devam eden erişiminiz güncel koşulları kabul ettiğiniz anlamına gelir.</p>

      <h2>11. Uygulanacak Hukuk</h2>
      <p>Bu koşullar Türkiye Cumhuriyeti kanunlarına tabidir. Uyuşmazlıklarda İstanbul mahkemeleri ve icra daireleri yetkilidir.</p>

      <h2>12. İletişim</h2>
      <p>Kullanım koşulları hakkında sorularınız için:</p>
      <p><strong>E-posta:</strong> info@isbulsun.com<br /><strong>Telefon:</strong> 0850 307 80 61</p>
    </div>
  </div>
);

export default TermsPage;
